import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, X } from 'lucide-react';
import { Button } from './ui/button';
import { useRGPDGamification } from '../hooks/useRGPDGamification';

// Bottom-right RGPD consent banner. Non-blocking, editorial style matching Fodindin.
// Auto-hides once the user makes a choice; can be re-opened via footer link.
export default function RGPDBanner() {
  const { state, setConsent } = useRGPDGamification();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Delay to avoid flashing during initial paint.
    if (state.consent) return undefined;
    const t = setTimeout(() => setVisible(true), 700);
    return () => clearTimeout(t);
  }, [state.consent]);

  if (!visible || state.consent) return null;

  const accept = () => { setConsent('accepted'); setVisible(false); };
  const reject = () => { setConsent('rejected'); setVisible(false); };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-labelledby="rgpd-banner-title"
      data-testid="rgpd-banner"
      className="fixed z-[9999] bottom-4 right-4 left-4 sm:left-auto sm:max-w-[400px] animate-in slide-in-from-bottom-4 fade-in duration-500"
    >
      <div className="rounded-2xl bg-[#1a1d1a] text-white shadow-2xl border border-white/10 backdrop-blur-md p-5">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-lg bg-[#5a8268] flex items-center justify-center shrink-0">
            <ShieldCheck className="w-4.5 h-4.5" />
          </div>
          <div className="flex-1 min-w-0">
            <h4 id="rgpd-banner-title" className="text-[14px] font-semibold">Vos épargnes sont sécurisées</h4>
            <p className="mt-1 text-[12.5px] text-white/70 leading-relaxed">
              Fodindin chiffre vos données financières (Mobile Money, comptes) en AES‑256 et n&apos;utilise <span className="text-white">aucun cookie tiers publicitaire</span>. Vos données ne sont jamais revendues.
            </p>
          </div>
          <button
            onClick={reject}
            aria-label="Fermer"
            data-testid="rgpd-banner-close"
            className="p-1 rounded hover:bg-white/10 text-white/50 hover:text-white transition-colors shrink-0"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="mt-4 flex flex-wrap gap-2 items-center">
          <Button
            onClick={accept}
            data-testid="rgpd-banner-accept"
            className="btn-anim h-9 rounded-full bg-[#d97757] hover:bg-[#c66745] text-white text-[12.5px] font-medium px-4"
          >
            J&apos;accepte
          </Button>
          <Button
            onClick={reject}
            data-testid="rgpd-banner-reject"
            variant="outline"
            className="btn-anim h-9 rounded-full bg-transparent border-white/20 hover:bg-white/10 text-white text-[12.5px] px-4"
          >
            Refuser
          </Button>
          <Link
            to="/rgpd"
            data-testid="rgpd-banner-learn-more"
            className="ml-auto text-[12.5px] text-white/70 hover:text-white underline underline-offset-2"
          >
            La charte complète →
          </Link>
        </div>
      </div>
    </div>
  );
}
